import BaseScopeCellContent from './BaseScopeCellContent'
import messageResource from '../../../../messageResource'
import {userNameLower} from '../../../../util/pluralizeUtils'

class TeamScopeCellContent extends BaseScopeCellContent {
    constructor() {
        super(null, {
            className: 'teamScopeContent',
        })

        this.state = {
            ...this.state,
            assignedUsersCount: 0,
        }
    }

    _isScopeEmpty() {
        return !this.state.allScope && this.state.assignedUsersCount === 0
    }

    _getSelectedScopeMessage() {
        return `${this.state.assignedUsersCount} ${userNameLower(this.state.assignedUsersCount)}`
    }

    _getEmptyScopeMessage() {
        return messageResource.getMessage('user_list.table.team_scope.not_selected')
    }

    _getNoAccessScopeMessage() {
        return messageResource.getMessage('user_list.table.team_scope.no_access')
    }

    _getAllScopeMessage() {
        return messageResource.getMessage('user_list.table.team_scope.all_users')
    }

    _getEmptyNotAvailableScopeMessage() {
        return messageResource.getMessage('user_list.table.team_scope.empty')
    }
}

export default TeamScopeCellContent



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/TeamScopeCellContent.js